export default {
  SET_KANBAN_DATA(state, value) {
    state.kanbanData = value;
  },
  SET_KANBAN_COL_DATA(state, value) {
    state.kanbanData.cols = value;
  },
  SET_ALL_BOARDS(state, value) {
    state.allBoards = value;
  },
  SET_CURRENT_BOARD(state, value) {
    state.currentBoard = value;
  },
  SET_CURRENT_BOARD_USERS(state, value) {
    state.currentBoardUsers = value;
  },
  SET_CURRENT_BOARD_USER(state, value) {
    state.currentBoardUsers.unshift(value);
  },
  SET_BOARD_INVITEES(state, value) {
    state.currentBoardUsers.unshift(value);
  },
  UPDATE_BOARD_INVITEES(state, value) {
    let index = state.currentBoardUsers.findIndex(cbu => cbu._id === value._id);
    state.currentBoardUsers[index] = value;
  },
  SET_USERS_IN_BOARD(state, value) {
    state.boardUsers = value;
  },
  CLEAR_CURRENT_BOARD(state) {
    state.currentBoardUsers = [];
    state.currentBoard = {};
    state.boardUsers = [];
  },
  SET_USER_LEVEL_BOARDS(state, value) {
    state.userLevelBoards = value;
  },
  SET_CURRENT_USER_LEVEL_BOARD(state, value) {
    state.currentUserLevelBoard = value;
  },
  SET_CURRENT_BOARD_USER_DETAILS(state, value) {
    state.currentBoardUserDetails = value;
  }
}
